import ExperimentContext from '@/context/ExperimentContext'
import pclnExperimentation from '@pcln/experimentation'
import { useContext, useEffect } from 'react'

type UseSetiParams = {
  experimentCode: string
  shouldFireImpression?: boolean
}

export default function useSeti({ experimentCode, shouldFireImpression = true }: UseSetiParams) {
  const { [experimentCode]: setiTest = 'DEFAULT' } = useContext(ExperimentContext)

  useEffect(() => {
    if (experimentCode && shouldFireImpression) {
      pclnExperimentation.fireImpression(experimentCode)
    }
  }, [experimentCode, shouldFireImpression])

  return setiTest
}
